




























import ListBody from '@/components/list/ListBody.vue';
import ListItem from '@/components/list/ListItem.vue';

interface Categories {
  [category: string]: Array<{
    title: string;
    isComplete: boolean;
    meta: {
      category: string;
    };
  }>;
}

export default {
  props: {
    actions: {
      type: Object,
      default: () => ({}),
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    categories() {
      return this.list.reduce((payload: Categories, item: any) => {
        const { category } = item.meta;
        if (!payload[category]) {
          payload[category] = [];
        }
        payload[category].push(item);
        return payload;
      }, {});
    },
  },
  methods: {
    performAction(item: any) {
      // run function if incomplete
      !item.isComplete
        && this.actions[item.title]();
    },
  },
  components: {
    ListBody,
    ListItem,
  },
} as IView;
